import { CSSProperties } from 'react';
import { searchType } from 'features/searchSchedule/models/searchType';

export const makeOptionStyle = (searchType: searchType): CSSProperties => {
  return searchType === 'main'
    ? {
        height: 60,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        margin: '0',
      }
    : {
        height: 45,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 16,
        margin: '0',
      };
};
